import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { useIdList, SHORTLIST_KEY } from "@/lib/idList";
import { StarButton } from "@/components/CareerActions";

export const ShortlistPanel = ({ token, careers }) => {
  const { ids } = useIdList(SHORTLIST_KEY);
  const rank = Object.fromEntries(careers.map((c, i) => [c.id, i + 1]));
  const mine = careers.filter((c) => ids.includes(c.id));
  return (
    <section className="mt-10 rounded-2xl bg-white border border-[#1C242B]/10 p-6" data-testid="shortlist-panel">
      <p className="overline-label flex items-center gap-2"><Star size={14} className="fill-[#D96B43] text-[#D96B43]" /> Your shortlist</p>
      {mine.length === 0 ? (
        <p className="mt-3 text-sm text-slate-600" data-testid="shortlist-empty">Star careers while you browse (here or on <Link to="/careers" className="underline">Explore careers</Link>) to see how well each one fits you.</p>
      ) : (
        <ul className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {mine.map((c) => (
            <li key={c.id} className="rounded-xl border border-[#1C242B]/10 p-4 flex items-start gap-3" data-testid={`shortlist-item-${c.id}`}>
              <div className="min-w-0 flex-1">
                <Link to={`/results/${token}/career/${c.id}`} className="font-display font-semibold text-[#1C242B] hover:text-[#D96B43] transition-colors">{c.title}</Link>
                <p className="mt-1 text-xs text-slate-500">#<span data-no-translate>{rank[c.id]}</span> of <span data-no-translate>{careers.length}</span> matches</p>
              </div>
              <span className="font-mono-ui text-xl font-semibold text-[#D96B43]" data-testid={`shortlist-score-${c.id}`}>{c.score}%</span>
              <StarButton id={c.id} testId={`shortlist-star-${c.id}`} />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
